import request from '@/utils/request'
import host from '@/api/base/host'

// 订单模块
const path = host.path('dev', { dev: 'v1/userWithdraw' })

export default {
  // 查询提现金额
  getWithdrawCash(data) {
    return request({
      url: path('getWithdrawCash'),
      method: 'post',
      data
    })
  },
  // 进行提现
  cash(data) {
    return request({
      url: path('cash'),
      method: 'post',
      data
    })
  },
  // 进行提现
  getCashHistory(data) {
    return request({
      url: path('getWithdrawCashHistory'),
      method: 'post',
      data
    })
  }
}
